import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";



// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDFpwgK5gvZ_VRo-EPd0lcVuUKYwBeBP2A",
  authDomain: "frivle.firebaseapp.com",
  databaseURL: "https://frivle-default-rtdb.firebaseio.com",
  projectId: "frivle",
  storageBucket: "frivle.appspot.com",
  messagingSenderId: "635674735493",
  appId: "1:635674735493:web:ac6bd569c16303550c0aec",
  measurementId: "G-PM8GCCW7F1"
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const firebaseDb = firebase.database();
